import { render, staticRenderFns } from "./ViewSwitcher.vue?vue&type=template&id=5b67c4e2&scoped=true&"
import script from "./ViewSwitcher.vue?vue&type=script&lang=ts&"
export * from "./ViewSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./ViewSwitcher.vue?vue&type=style&index=0&id=5b67c4e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b67c4e2",
  null
  
)

export default component.exports